import(/* webpackMode: "eager" */ "/root/project/app/app/global-error.tsx");
